<script setup>
  const props = defineProps({
    type: {
      type: String,
      default: 'default',
    },
  })
</script>

<template>
  <div class="m-headingForT-contentBox" :class="`m-headingForT-contentBox--${props.type}`">
    <div class="m-headingForT-contentBox__content">
      <slot />
    </div>
    <div class="m-headingForT-contentBox__bg m-headingForT-contentBox__bg--top" />
    <div class="m-headingForT-contentBox__bg m-headingForT-contentBox__bg--mid" />
    <div class="m-headingForT-contentBox__bg m-headingForT-contentBox__bg--bottom" />
    <div class="m-headingForT-contentBox__bg-base" />
  </div>
</template>

<style lang="scss" scoped>
  .m-headingForT-contentBox {
    width: 53vw;
    margin: 3.8vw auto 5.8vw;
    padding: 1.2vw 3vw 1.2vw;
    position: relative;
    z-index: 2;
  }

  .m-headingForT-contentBox__bg-base {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: -1.8vw;
    width: 98%;
    height: calc(100% + 1.9vw + 2vw);
    background: rgba(#191b3d, 0.75);
    border-top-left-radius: 2vw;
    border-bottom-right-radius: 2vw;
  }
  .m-headingForT-contentBox--v2 {
    width: 60vw;
    margin: 3.8vw auto 5.8vw;
    padding: 1.2vw 3.5vw 1.2vw;
    position: relative;
    .m-headingForT-contentBox__bg--top {
      background-image: url('~@/assets/images/microsites/headingfortomorrow/_components/content-box/v2/desktop/bg-top.png');
    }
    .m-headingForT-contentBox__bg--mid {
      background-image: url('~@/assets/images/microsites/headingfortomorrow/_components/content-box/v2/desktop/bg-mid.png');
    }
    .m-headingForT-contentBox__bg--bottom {
      background-image: url('~@/assets/images/microsites/headingfortomorrow/_components/content-box/v2/desktop/bg-bottom.png');
    }
    .m-headingForT-contentBox__bg-base {
      background: rgba(#1271a9, 0.75);
    }
  }

  .m-headingForT-contentBox__content {
    position: relative;
    z-index: 2;
  }
  .m-headingForT-contentBox__bg {
    position: absolute;
    transform: translateX(-50%);
    width: 100%;
    left: 50%;
    z-index: 1;
  }
  .m-headingForT-contentBox__bg--top {
    background: url('~@/assets/images/microsites/headingfortomorrow/_components/content-box/default/desktop/bg-top.png')
      no-repeat center center / 100% auto;
    height: 1.8vw;
    transform: translate(-50%, -100%);
    top: 0.05lvw;
    z-index: 2;
  }
  .m-headingForT-contentBox__bg--mid {
    top: 0;
    height: 100%;
    background: url('~@/assets/images/microsites/headingfortomorrow/_components/content-box/default/desktop/bg-mid.png')
      repeat-y center center / 100% auto;
  }
  .m-headingForT-contentBox__bg--bottom {
    background: url('~@/assets/images/microsites/headingfortomorrow/_components/content-box/default/desktop/bg-bottom.png')
      no-repeat center center / 100% auto;
    height: 2.15vw;
    transform: translate(-50%, 100%);
    bottom: 0.05vw;
    z-index: 2;
  }
  .tablet {
    .m-headingForT-contentBox {
      width: 95.5vw;
      padding: 3vw 3.5vw 4vw;
      margin: 5vw auto 10vw;
    }
    .m-headingForT-contentBox__bg--top {
      height: 3.3vw;
    }
    .m-headingForT-contentBox__bg--bottom {
      height: 3.7vw;
    }

    .m-headingForT-contentBox--v2 {
      .m-headingForT-contentBox__bg--top {
        height: 3.2vw;
      }
      .m-headingForT-contentBox__bg--mid {
      }
      .m-headingForT-contentBox__bg--bottom {
      }
      .m-headingForT-contentBox__bg-base {
      }
    }
  }

  .mobile {
    .m-headingForT-contentBox {
      width: 95vw;
      margin: 7vw auto 8.5vw;
      padding: 2.8vw 3.5vw 3.5vw;
    }

    .m-headingForT-contentBox__bg--top {
      background: url('~@/assets/images/microsites/headingfortomorrow/_components/content-box/default/mobile/bg-top.png')
        no-repeat center bottom / 100% auto;
      height: 3vw;
      transform: translate(-50%, -100%);
      top: 0.1vw;
    }
    .m-headingForT-contentBox__bg--mid {
      top: 0;
      height: 100%;
      background: url('~@/assets/images/microsites/headingfortomorrow/_components/content-box/default/mobile/bg-mid.png')
        repeat-y center center / 100% auto;
    }
    .m-headingForT-contentBox__bg--bottom {
      background: url('~@/assets/images/microsites/headingfortomorrow/_components/content-box/default/mobile/bg-bottom.png')
        no-repeat center top / 100% auto;
      height: 3.3vw;
      transform: translate(-50%, 100%);
      bottom: 0.1vw;
    }
  }
</style>
